

// import Swiper from 'swiper/js/swiper'
// import 'swiper/css/swiper.css'

// function orangutan(callback) {
//     callback(swiper)
// }

// let swiper = new Swiper('.swiper-container', {
//     slidesPerView: 2,
//     spaceBetween: 30,
//     // centeredSlides: true,
//     // watchOverflow: true,
//     lazy: true,
//     // slidesPerGroup: 3,
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });

// function beerme() {
//     swiper.update()
// }

// // orangutan(beerme)

// setTimeout(beerme, 100)


// import {tns} from 'tiny-slider/src/tiny-slider'
// import 'tiny-slider/dist/tiny-slider.css'

// var slider = tns({
//   container: '.slider-container',
//   autoWidth: true,
//   items: 3,
//   slideBy: 1,
//   gutter: 5,
// //   loop: false,
//   controlsContainer: '.controls-container',
//   prevButton: '#prev',
//   nextButton: '#next',
//   nav: false
// });

import Flickity from 'flickity/dist/flickity.pkgd'
import 'flickity/dist/flickity.css'

import { findElement } from '../helpers'

document.addEventListener('turbolinks:load', () => {
    $('.custom-file input').change(function (e) {
        $(this).next('.custom-file-label').html(e.target.files[0].name);
    });
    
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })
    
    $('.popup-group').each(function() {
        $(this).find('a').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    })
    
    $('.popup-item').magnificPopup({
        type: 'image'
    })



    let flickityElement = findElement('.flickity-container')

    if (flickityElement)
    {
        let cellSize = document.querySelector(".flickity-container div a img").clientHeight

        var flkty = new Flickity( flickityElement, {
            // options
            cellAlign: 'left',
            contain: true
        });

        console.log('Flickity Loaded')
    }
})



console.log('Bottom scripts loaded.')